module.exports = __webpack_public_path__ + "static/img/Z_IMG_20151230_123315.bf516d73.jpg";